import React, { useState } from 'react';
import { User, Mail, Phone, MessageSquare, Send } from 'lucide-react';
import ReCAPTCHA from "react-google-recaptcha";
import './ContactusForm.css';

const ContactForm = ({ hideTitle = false, hideEmail = false, customTitle = "שלח לנו פנייה" }) => {
  const [formData, setFormData] = useState({
    name: '',
    subject: '',
    email: '',
    phone: '',
    message: ''
  });

  const [captchaValue, setCaptchaValue] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaValue) {
      alert('אנא אמת שאתה לא רובוט');
      return;
    }

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ ...formData, captcha: captchaValue })
      });

      const result = await response.json();
      if (result.success) {
        alert('הטופס נשלח בהצלחה!');
        setFormData({ name: '', subject: '', email: '', phone: '', message: '' });
        setCaptchaValue(null);
      } else {
        alert('שגיאה בשליחת הטופס');
      }
    } catch (error) {
      console.error('❌ שגיאה:', error);
      alert('שגיאה בשליחת הנתונים');
    }
  };

  return (
    <div className="ContactUsFormContainer">
      {!hideTitle && (
  <h2 className="ContactUsFormTitle">{customTitle}</h2>
)}


      <form onSubmit={handleSubmit} className="ContactUsForm">
        <div className="ContactUsFormInputGroup">
          <div className="ContactUsFormIcon"><User size={18} /></div>
          <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="שם" required className="ContactUsFormInput" />
        </div>

        <div className="ContactUsFormInputGroup">
          <div className="ContactUsFormIcon"><MessageSquare size={18} /></div>
          <input type="text" name="subject" value={formData.subject} onChange={handleChange} placeholder="נושא" required className="ContactUsFormInput" />
        </div>

{!hideEmail && (
  <div className="ContactUsFormInputGroup">
    <div className="ContactUsFormIcon"><Mail size={18} /></div>
    <input
      type="email"
      name="email"
      value={formData.email}
      onChange={handleChange}
      placeholder="דואר אלקטרוני"
      required
      className="ContactUsFormInput"
    />
  </div>
)}

        <div className="ContactUsFormInputGroup">
          <div className="ContactUsFormIcon"><Phone size={18} /></div>
          <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="טלפון נייד" required className="ContactUsFormInput" />
        </div>

        <div className="ContactUsFormInputGroup">
          <textarea name="message" value={formData.message} onChange={handleChange} placeholder="תוכן הפניה" required className="ContactUsFormTextarea" />
        </div>

  {/* reCAPTCHA חייב להיות כאן */}
  <div className="ReCaptchaBox">
    <ReCAPTCHA
      sitekey="6LcMcP0qAAAAAJKQPThonCPeHq2lmXlakfO0e-AE"
      onChange={handleCaptchaChange}
    />
  </div>

  <button type="submit" className="ContactUsFormBtn" disabled={!captchaValue}>
  <Send size={18} />
  <span>שלח</span>
</button>
</form>
    </div>
  );
};

export default ContactForm;
